module.exports = __webpack_public_path__ + "static/img/seckill_tag.94ebbd66.png";